
import { supabase } from "@/integrations/supabase/client";
import { Profile } from "./types";
import { createLogger } from "../utils/loggingUtils";
import { toast } from "sonner";

const logger = createLogger('fetchAllProfiles');

export const fetchAllProfiles = async (): Promise<Profile[]> => {
  try {
    logger.info("Fetching all public profiles");
    
    const { data, error } = await supabase
      .from("profiles")
      .select(`
        id,
        username,
        display_username,
        lab,
        university,
        location,
        city,
        country,
        research_interests,
        expertise,
        linkedin_url,
        website_url,
        credit_balance,
        is_admin,
        email_notifications,
        notify_swap_offers,
        notify_swap_responses,
        daily_digest_email,
        created_at
      `)
      .eq('approval_status', 'approved')
      .neq('is_deleted', true)
      .order('display_username', { ascending: true })
      .order('username', { ascending: true });

    if (error) {
      logger.error("Error fetching profiles:", error);
      toast.error("Failed to load community profiles");
      return [];
    }

    logger.info(`Successfully fetched ${data.length} profiles`);
    return data as Profile[];
  } catch (error) {
    logger.error("Exception fetching profiles:", error);
    toast.error("An unexpected error occurred");
    return [];
  }
};
